export default __webpack_public_path__ + "static/media/step_03_active.734e7274.svg";